import { useEffect, useState } from 'react';
import { Route } from '~/Constants/Routes.constants';
import { useNavigation, useUserWithoutContext, useRequest, useLocalStorage } from '~/Hooks';
import { IErrorResponse } from '../../../Models/DTO/Error.models';
import { verifyAccountWithToken } from '../helpers/APIs';

export const useOnboardingConfirmation = () => {
  const { getParameterByName, navigate } = useNavigation();
  const { forceRefreshUser } = useUserWithoutContext();
  const { requestWithCallback } = useRequest();
  const { logout } = useLocalStorage();

  const [networkError, setNetworkError] = useState<IErrorResponse>({});
  const [confirmationSuccess, setConfirmationSuccess] = useState<boolean>();
  const [isLoading, setLoading] = useState<boolean>(false);

  const token = getParameterByName('token');

  useEffect(() => {
    confirmAccount(token);
  }, [token]);

  const onRedirectToLogin = () => {
    logout();
    navigate(Route.LOGIN);
  };

  const onRedirectToDashboard = () => {
    navigate(Route.HOME);
  };

  const confirmAccount = (token: string | null) => {
    if (token) {
      setLoading(true);
      verifyAccountWithToken(
        requestWithCallback,
        token,
        async () => {
          await forceRefreshUser();
          setConfirmationSuccess(true);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          setNetworkError(error);
        },
      );
    }
  };

  return {
    networkError,
    confirmationSuccess,
    isLoading,
    onRedirectToLogin,
    onRedirectToDashboard,
  };
};
